<template>
  <!-- 考勤规则新增/编辑表单 -->
  <a-modal
    :title="formTitle || '新增考勤规则'"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <!-- 表单内容 -->
    <a-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 规则名称（必填） -->
          <a-form-item label="规则名称" name="name">
            <a-input v-model:value="form.name" placeholder="请输入规则名称" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 开始时间（必填） -->
          <a-form-item label="开始时间" name="startTime">
            <a-time-picker
              v-model:value="form.startTime"
              placeholder="请选择开始时间"
              style="width: 100%"
              format="HH:mm"
              valueFormat="HH:mm"
              allow-clear
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 结束时间（必填） -->
          <a-form-item label="结束时间" name="endTime">
            <a-time-picker
              v-model:value="form.endTime"
              placeholder="请选择结束时间"
              style="width: 100%"
              format="HH:mm"
              valueFormat="HH:mm"
              allow-clear
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 每日工作时长(小时) -->
          <a-form-item label="每日工作时长(小时)" name="workingHours">
            <a-input-number
              v-model:value="form.workingHours"
              placeholder="请输入每日工作时长(小时)"
              :min="0"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 是否跨天 -->
          <a-form-item label="是否跨天" name="isOvernight">
            <a-select
              v-model:value="form.isOvernight"
              placeholder="请选择是否跨天"
              allow-clear
            >
              <a-select-option
                v-for="(d, index) in dict.type['is_overnight']"
                :key="d.value"
                :value="d.value"
                >{{ d.label }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 工作天数规则 -->
          <a-form-item label="工作天数规则" name="workRules">
            <a-select
              v-model:value="form.workRules"
              placeholder="请选择工作天数规则"
              allow-clear
            >
              <a-select-option
                v-for="(d, index) in dict.type['working_days_rules']"
                :key="d.value"
                :value="d.value"
                >{{ d.label }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 工作天数 -->
          <a-form-item label="工作天数" name="workingDays">
            <a-input-number
              v-model:value="form.workingDays"
              placeholder="请输入工作天数"
              :min="0"
              style="width: 100%"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 操作按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import {
  getAttendance,
  addAttendance,
  updateAttendance,
} from '@/api/system/attendance'

export default {
  name: 'CreateForm',
  props: {},
  components: {},
  dicts: ['is_overnight', 'working_days_rules'],
  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数（仅保留页面实际需要的字段）
      form: {
        id: null,

        projectId: null,
        name: null,
        startTime: null,
        endTime: null,
        workingHours: null,
        isOvernight: null,
        workRules: null,
        workingDays: null,
      },
      // 1-新增，2-编辑
      formType: 1,
      open: false,
      // 表单校验规则
      rules: {
        name: [
          { required: true, message: '规则名称不能为空', trigger: 'blur' },
        ],
        startTime: [
          { required: true, message: '开始时间不能为空', trigger: 'change' },
        ],
        endTime: [
          { required: true, message: '结束时间不能为空', trigger: 'change' },
        ],
        workingHours: [
          { required: true, message: '每日工作时长不能为空', trigger: 'change' },
        ],
        isOvernight: [
          { required: true, message: '是否跨天不能为空', trigger: 'change' },
        ],
      },
    }
  },
  created() {},
  computed: {},
  watch: {
    'form.startTime': function () {
      this.updateWorkingHours()
    },
    'form.endTime': function () {
      this.updateWorkingHours()
    },
    'form.isOvernight': function () {
      this.updateWorkingHours()
    },
  },
  methods: {
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        projectId: null,
        name: null,
        startTime: null,
        endTime: null,
        workingHours: null,
        isOvernight: null,
        workRules: null,
        workingDays: null,
      }
    },
    /** 新增按钮操作：需要先选择项目 */
    handleAdd(row) {
      // 从 Vuex 获取当前项目ID
      const currentProjectId = this.$store.getters.currentProjectId
      if (!currentProjectId) {
        this.$message.warning('请先选择项目', 3)
        return
      }
      this.reset()
      this.formType = 1
      // 设置项目ID
      this.form.projectId = currentProjectId
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作：加载规则详情 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAttendance({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm() {
      // 表单验证
      this.$refs.form.validate().then(() => {
        this.submitLoading = true
        // 判断是修改还是新增
        if (this.form.id !== undefined && this.form.id !== null) {
          // 修改操作
          updateAttendance(this.form)
            .then((response) => {
              this.$message.success('修改成功', 3)
              this.open = false
              // 触发父组件刷新事件
              $emit(this, 'ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          // 新增操作
          addAttendance(this.form)
            .then((response) => {
              this.$message.success('新增成功', 3)
              this.open = false
              // 触发父组件刷新事件
              $emit(this, 'ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      }).catch(() => {
        // 验证失败
        return false
      })
    },
    /**
     * 根据开始结束时间计算每日工作时长（小时）
     * 保留两位小数，若用户需要可再手动调整
     */
    updateWorkingHours() {
      const { startTime, endTime } = this.form
      if (!startTime || !endTime) {
        this.form.workingHours = null
        return
      }
      const startMinutes = this.parseTimeToMinutes(startTime)
      const endMinutes = this.parseTimeToMinutes(endTime)
      if (startMinutes === null || endMinutes === null) {
        this.form.workingHours = null
        return
      }
      let diffMinutes = endMinutes - startMinutes
      if (diffMinutes < 0) {
        diffMinutes += 24 * 60
      }
      const hours = diffMinutes / 60
      this.form.workingHours = Number(hours.toFixed(2))
    },
    /**
     * 时间字符串转换为分钟
     */
    parseTimeToMinutes(timeStr) {
      if (!timeStr || typeof timeStr !== 'string') {
        return null
      }
      const parts = timeStr.split(':')
      if (parts.length < 2) {
        return null
      }
      const hour = parseInt(parts[0], 10)
      const minute = parseInt(parts[1], 10)
      if (isNaN(hour) || isNaN(minute)) {
        return null
      }
      return hour * 60 + minute
    },
  },
  emits: ['ok', 'close'],
}
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 60px 4px !important;
}

/* 表单左边距调整 - 使用全局样式 */
.create-form-modal .ant-form {
  margin-left: -24px !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 时间选择器样式 */
.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 减少列之间的间距 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

/* 调整标签对齐，确保不会过于靠右 */
.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}
</style>
